/**
 * @module icons
 */
import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { iconActions } from '~/behaviors/actions/icon.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeIcons = (state, action) => {
  const icons = action?.payload?.entities?.icons || {};

  Object.values(icons).forEach((icon) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[icon.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[icon.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...icon,
    };
  });
};

const icons = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(iconActions.fetchAllIcons.fulfilled, mergeIcons);
});

export default icons;
